import React from "react";
import { Carousel } from "react-responsive-carousel";
import "./testimonial.css";

export default function Testimonial() {
  return (
    <section className="testimonial-section">
      <div className="testimonial-inner">
        <div className="testimonial-header">
          <div className="testimonial-eyebrow">Iskustva klijenata</div>
          <h2 className="testimonial-title">ZADOVOLJNI KLIJENTI</h2>
        </div>

        <Carousel
          autoPlay
          infiniteLoop
          emulateTouch
          showStatus={false}
          showThumbs={false}
          interval={10000}
        >
          <div className="container-testimonial">
            <div className="person-img person1" />
            <h3>Slavica Srejić</h3>
            <p>
              <q>
                Dragi posetioci ove stranice, pre svega da vam kažem da nisam
                upoznala posvećenijeg trenera, što je nešto najbitnije kada se
                odlučite da unajmite profesionalnog trenera. Trener, kao što je
                Mihailo je jako kompetetan, trening kod istog svrsishodan i
                pruža primenljivo znanje. Sa njim sam naučila nešto novo, dobila
                odgovore na mnoga pitanja i sa sigurnošću govorim da će mi
                znanje stečeno na treningu pomoći za moj dalji napredak.
              </q>
            </p>
          </div>
          <div className="container-testimonial">
            <div className="person-img person2" />
            <h3>Tea Brujić</h3>
            <p>
              <q>
                Nadam se da ćeš ovo pročitati ako si posetio ovu stranicu. Prvo,
                stručnost neću ni da komentarišem — samo ću reći: svaka čast.
                Treniram sa njim već skoro 3 godine i mislim da u životu nisam
                dobila takvu antistres terapiju kakvu ova osobica pruža. Toliko
                smeha, zabave i priče, ispraćene radom na sebi. Radiš na svom
                zdravlju u svakom smislu te reči — i psihički i fizički.
              </q>
            </p>
          </div>
          <div className="container-testimonial">
            <div className="person-img person3" />
            <h3>Kristijan Cesnak</h3>
            <p>
              <q>
                Počeo sam sa treninzima kako bih ojačao mišiće, pre svega leđne
                zbog dugog sedenja na poslu. Mihailo je veoma posvećen
                treninzima — pri pokazivanju pravilnog izvođenja vežbi,
                asistenciji, davanju saveta oko ishrane. Veoma sam zadovoljan
                rezultatima. Svima preporučujem saradnju sa njim.
              </q>
            </p>
          </div>
          <div className="container-testimonial">
            <div className="person-img person4" />
            <h3>Tanja Gligorić</h3>
            <p>
              <q>
                Mihailo ima izuzetno ličan pristup u formiranju treninga, izboru
                tempa rada i dinamici svakog pojedinačnog časa. Svaki trening je
                drugačiji i podređen cilju koji smo postavili na početku saradnje.
                Mihailovo znanje, posvećenost i sposobnost da motiviše u trenucima
                kad je to najpotrebnije su nemerljivi.
              </q>
            </p>
          </div>
          <div className="container-testimonial">
            <div className="person-img person5" />
            <h3>Miroslav Sapundžić</h3>
            <p>
              <q>
                Počeci u svetu fitnessa uz saradnju sa Mihailom pokazali su se
                kao odličan izbor. Njegovi treninzi su uvek sa pravom merom dobro
                isplaniranog i efikasnog rada. Mihailova stručnost, profesionalna
                pasija i maksimalna posvećenost klijentu zaslužni su za brzo
                vidljive rezultate i podizanje samopouzdanja.
              </q>
            </p>
          </div>
          <div className="container-testimonial">
            <div className="person-img person6" />
            <h3>Nikola Ajzenhamer</h3>
            <p>
              <q>
                Kao početniku veoma mi je bilo važno da imam trenera koji će sa
                jedne strane prilagoditi trening mojim mogućnostima, a sa druge
                strane pružiti dosta znanja. Mihailo je upravo takav trener. Već
                od prvog treninga sam naučio dosta toga o vežbanju, ishrani i
                dobrim navikama.
              </q>
            </p>
          </div>
        </Carousel>
      </div>
    </section>
  );
}
